import * as React from 'react'

// Components
import { Link } from 'components/link'

// Config
import { requestPlan } from 'config/routes'

// Modules
import { DI } from 'modules'

const DownloadSliderRequestPlan = ({ common }) => {
  const { strings } = common

  // Root className
  const rootCln = 'side-buy-plan'

  return (
    <>
      <div className="side-popup-line" />

      <div className={`${rootCln}__text ${rootCln}__text-padded`}>
        {strings['page.video.slider.pass_info']}
      </div>

      <Link
        className={`btn-bord ${rootCln}__btn`}
        to={requestPlan.getPath('', 'enterprise')}
      >
        {strings['page.payment.summary.pass.decline.request_enterprise']}
      </Link>
    </>
  )
}

export default DI(['common'])(DownloadSliderRequestPlan)
